import(/* webpackMode: "eager" */ "/app/app/(data-intensive)/project/layout.tsx");
